function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.941 10.191a4.314 4.314 0 100-8.627 4.314 4.314 0 000 8.627z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.647 11.52a2.795 2.795 0 000 5.588 2.796 2.796 0 002.795-2.795 2.796 2.796 0 00-2.795-2.793zm0 1.176a1.619 1.619 0 010 3.236 1.619 1.619 0 010-3.235z",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.235 12.107v-1.323a.588.588 0 00-1.176 0v1.324a.589.589 0 001.176 0zM16.623 13.17l.935-.936a.587.587 0 10-.831-.832l-.937.936a.59.59 0 000 .832.59.59 0 00.833 0zM16.853 14.902h1.323a.588.588 0 000-1.177h-1.323a.588.588 0 000 1.177zM15.79 16.29l.937.935a.587.587 0 10.831-.832l-.935-.936a.59.59 0 00-.833 0 .59.59 0 000 .832zM14.059 16.52v1.323a.588.588 0 001.176 0V16.52a.59.59 0 00-1.176 0zM12.671 15.457l-.935.936a.587.587 0 10.831.832l.936-.936a.59.59 0 000-.832.59.59 0 00-.832 0zM12.44 13.725h-1.322a.588.588 0 000 1.177h1.323a.588.588 0 100-1.177zM13.503 12.338l-.936-.936a.587.587 0 10-.831.832l.935.936a.59.59 0 00.832 0 .59.59 0 000-.832z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.067 17.651a1.373 1.373 0 01.114-1.812l.152-.153h-.216a1.373 1.373 0 010-2.745h.216l-.152-.153a1.372 1.372 0 01-.061-1.875c-.384-.03-.778-.046-1.179-.046-2.605 0-4.912.652-6.344 1.628-1.093.746-1.695 1.692-1.695 2.686v1.137a1.331 1.331 0 001.333 1.333h7.832z",
  fill: "#fff"
});

function SvgSettingsUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default SvgSettingsUser;